import React from 'react';
import { Box, Typography, Tooltip, Fab } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import AddIcon from '@mui/icons-material/Add';

import ChipFilter from '../../../../components/filters/ChipFilter';
import styles from './OperatorFilters.styles';

export default function OperatorFilters({
  filters,
  setFilters,
  nameOptions,
  operatorOptions,
  onAdd,
  onExport,
}) {
  const toggleFilter = (type, value) => {
    setFilters((prev) => {
      const current = prev[type] || [];
      const updated = current.includes(value)
        ? current.filter((o) => o !== value)
        : [...current, value];
      return { ...prev, [type]: updated };
    });
  };

  const clearFilter = (type) => {
    setFilters((prev) => ({ ...prev, [type]: [] }));
  };

  return (
    <Box sx={styles.filterRow}>
      <Box sx={styles.filterLeft}>
        <Typography sx={{ fontSize: '0.875rem', fontWeight: 600 }}>Filters:</Typography>

        <ChipFilter
          label="Operator"
          type="name"
          values={nameOptions}
          selectedValues={filters.name}
          onToggle={toggleFilter}
          onClear={clearFilter}
        />

        <ChipFilter
          label="Code"
          type="operator"
          values={operatorOptions}
          selectedValues={filters.operator}
          onToggle={toggleFilter}
          onClear={clearFilter}
        />
      </Box>

      <Box sx={styles.rightControls}>
        <Tooltip title="Export to CSV" arrow>
          <Fab size="small" sx={styles.fabButton} onClick={onExport}>
            <FileDownloadIcon fontSize="small" />
          </Fab>
        </Tooltip>

        <Tooltip title="Create new operator" arrow>
          <Fab size="small" sx={styles.fabButton} onClick={onAdd}>
            <AddIcon fontSize="small" />
          </Fab>
        </Tooltip>
      </Box>
    </Box>
  );
}
